import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { AppNavigate } from 'components/AppComponents';
import { LocalStorageKeys } from 'appConstants/LocalStorageKeys';

export const RaceRef: React.FC = () => {
  const { userRef } = useParams();

  useEffect(() => {
    localStorage.setItem(LocalStorageKeys.RACE_REFERRAL, userRef || '');
  }, []);

  return <AppNavigate to="/race" />;
};
